import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { isApiError } from "../../api/common";
import { ErrorHandlerCreator } from "../../utils/errorHandling";

const useNotFoundHandlerCreator = (): ErrorHandlerCreator => {
    const history = useHistory();

    return useCallback(
        (next) => {
            return (error) => {
                if (isApiError(error)) {
                    if (error.status === 404) {
                        history.push("/not-found");
                    } else {
                        next(error);
                    }
                } else {
                    next(error);
                }
            };
        },
        [history],
    );
};

export default useNotFoundHandlerCreator;
